import { showToast } from '../../../collections/CollectionUI.js';
import { showConfirmDialog } from '../../utils/dialog.js';
import {
    ensureItemsModalState,
    disableVisibleCheckboxes,
} from './state.js';

export async function handleBulkDelete() {
    const state = ensureItemsModalState(this);
    if (state.selectedIds.size === 0 || !this.currentCollectionId) {
        return;
    }

    if (state.isBulkDeleting) {
        return;
    }

    const count = state.selectedIds.size;
    const confirmed = await showConfirmDialog({
        title: `Xóa ${count} dự án`,
        message: `Bạn có chắc chắn muốn xóa ${count} dự án đã chọn khỏi collection?`,
        confirmText: 'Xóa tất cả',
        cancelText: 'Hủy',
        type: 'danger',
    });

    if (!confirmed) {
        return;
    }

    const bulkDeleteBtn = document.getElementById('bulk-delete-btn');
    const originalButtonHTML = bulkDeleteBtn?.innerHTML;
    state.isBulkDeleting = true;

    if (bulkDeleteBtn) {
        bulkDeleteBtn.innerHTML = `
            <svg class="animate-spin h-4 w-4 inline mr-1" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                <path d="M4 12a8 8 0 0 1 8-8" />
                <path d="M12 4a8 8 0 0 1 8 8" />
            </svg>
            Đang xóa...
        `;
        bulkDeleteBtn.setAttribute('disabled', 'disabled');
    }

    disableVisibleCheckboxes(true);

    const fdiIds = Array.from(state.selectedIds);
    try {
        const { results } = await this.api.bulkRemoveItems(this.currentCollectionId, fdiIds);

        let successCount = 0;
        let failureCount = 0;

        for (let index = 0; index < results.length; index += 1) {
            const result = results[index];
            const id = fdiIds[index];
            if (!id) {
                continue;
            }

            if (result.status === 'fulfilled') {
                successCount += 1;
                await this.removeItemElement(id);
                state.selectedIds.delete(id);
            } else {
                failureCount += 1;
                console.error('Bulk remove failed for', id, result.reason);
            }
        }

        if (successCount > 0) {
            showToast('success', `Đã xóa ${successCount} dự án khỏi collection`);
            this.decrementCollectionCount(successCount);
        }

        if (failureCount > 0) {
            showToast('warning', `${failureCount} dự án không thể xóa. Vui lòng thử lại.`);
        }
    } catch (error) {
        console.error('Bulk delete error:', error);
        showToast('error', error?.message || 'Có lỗi xảy ra khi xóa các dự án');
    } finally {
        state.isBulkDeleting = false;
        disableVisibleCheckboxes(false);
        if (bulkDeleteBtn) {
            bulkDeleteBtn.innerHTML = originalButtonHTML || 'Xóa đã chọn';
        }
        this.updateItemsAfterMutation();
    }
}

export async function removeItemFromCollection(fdiId, collectionId, triggerButton) {
    if (!fdiId || !collectionId) {
        return;
    }

    const confirmed = await showConfirmDialog({
        title: 'Xóa dự án khỏi collection',
        message: 'Bạn có chắc chắn muốn xóa dự án này?',
        confirmText: 'Xóa',
        cancelText: 'Hủy',
        type: 'danger',
    });

    if (!confirmed) {
        return;
    }

    const itemElement = document.querySelector(`[data-fdi-id="${fdiId}"]`);
    const originalButtonHTML = triggerButton?.innerHTML;

    itemElement?.classList.add('opacity-60', 'pointer-events-none');
    if (triggerButton) {
        triggerButton.innerHTML = `
            <svg class="animate-spin h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 4v4m0 8v4m8-8h-4M8 12H4" />
            </svg>
        `;
        triggerButton.disabled = true;
    }

    let succeeded = false;

    try {
        await this.api.removeItem(collectionId, fdiId);
        await this.removeItemElement(String(fdiId));
        this.decrementCollectionCount(1);
        showToast('success', 'Đã xóa dự án khỏi collection');
        succeeded = true;
    } catch (error) {
        console.error('Error removing item from collection:', error);
        showToast('error', error?.message || 'Không thể xóa dự án khỏi collection');
    } finally {
        if (!succeeded) {
            itemElement?.classList.remove('opacity-60', 'pointer-events-none');
            if (triggerButton) {
                triggerButton.innerHTML = originalButtonHTML || '';
                triggerButton.disabled = false;
            }
        }
    }

    if (succeeded) {
        this.updateItemsAfterMutation();
    }
}
